/*
  Language chooser for the Canada store.

  Stores the visitor's preferred language in a cookie and sends them to the
  same page in that language rather than dumping them on the homepage.
  Replaces the prompt Transcy used to render.

  The prompt only appears when the page they are on does not already match
  their stored preference, so choosing a language stops it for good. Closing
  it without choosing stores "dismissed" and stops it too.

  The preference lives in localStorage rather than a cookie. The Osano consent
  manager on this store replaces document.cookie and blocks writes it does not
  recognise, which silently dropped the cookie and made the prompt reappear
  after the visitor had already answered it. The cookie is still written as a
  fallback for anyone with localStorage unavailable.

  Markup lives in snippets/language-popup.liquid.
*/
(function () {
  var modal = document.getElementById('language-popup');
  if (!modal) return;
  if (window.Shopify && Shopify.designMode) return;

  var cookieName = modal.getAttribute('data-cookie-name') || 'ba_language';
  var cookieDays = parseInt(modal.getAttribute('data-cookie-days'), 10) || 365;
  var currentLanguage = modal.getAttribute('data-current-language') || '';

  var roots = [];
  try {
    roots = JSON.parse(modal.getAttribute('data-language-roots') || '[]');
  } catch (e) {
    return;
  }

  //normalise, Shopify returns "/" for the primary language and "/fr" for the rest
  function normaliseRoot(root) {
    if (!root || root === '/') return '/';
    return root.replace(/\/+$/, '');
  }
  roots = roots.map(normaliseRoot);

  var DISMISSED = 'dismissed';

  //recommendation label per language, falls back to no label
  var recommendedLabel = { en: 'Recommended', fr: 'Recommandé' };

  function getCookie(name) {
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(name + '=') === 0) {
        var value = part.substring(name.length + 1);
        return value === '' ? null : value;
      }
    }
    return null;
  }

  //localStorage first, the cookie is only a fallback, see the note at the top
  function readPreference() {
    try {
      var stored = window.localStorage.getItem(cookieName);
      if (stored) return stored;
    } catch (e) {}
    return getCookie(cookieName);
  }

  function writePreference(value) {
    if (!value) return;
    try {
      window.localStorage.setItem(cookieName, value);
    } catch (e) {}
    setCookie(cookieName, value, cookieDays);
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
  }

  //current path with any published language prefix removed, query and hash kept
  function currentPath() {
    var path = window.location.pathname || '/';
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root === '/' || !root) continue;
      if (path === root || path.indexOf(root + '/') === 0) {
        path = path.slice(root.length);
        break;
      }
    }
    if (path.charAt(0) !== '/') path = '/' + path;
    return path + window.location.search + window.location.hash;
  }

  //same page, different language
  function urlFor(root) {
    var path = currentPath();
    if (root === '/' || !root) return path;
    return root + (path === '/' ? '' : path);
  }

  //skip when they closed the prompt, or when this page is already in the
  //language they picked. a stored preference that does not match the page
  //means they landed somewhere else, so offer the switch again.
  var preference = readPreference();
  if (preference === DISMISSED) return;
  if (preference && preference === currentLanguage) return;

  var options = modal.querySelectorAll('.language-popup__option');
  if (!options.length) return;

  //browser language, e.g. fr-CA becomes fr
  var browserLanguage = (navigator.language || navigator.userLanguage || '').slice(0, 2).toLowerCase();

  Array.prototype.forEach.call(options, function (option) {
    var root = normaliseRoot(option.getAttribute('data-language-root'));
    var code = option.getAttribute('data-language-code') || '';

    option.setAttribute('href', urlFor(root));

    if (code.slice(0, 2).toLowerCase() === browserLanguage && code !== currentLanguage && recommendedLabel[code]) {
      var note = document.createElement('span');
      note.className = 'language-popup__recommended';
      note.textContent = recommendedLabel[code];
      option.appendChild(note);
    }

    option.addEventListener('click', function () {
      writePreference(code);
    });
  });

  //the theme uses #ajaxBusy as the modal backdrop, same as sections/pop-up.liquid
  var backdrop = document.getElementById('ajaxBusy');
  var container = modal.querySelector('.modal-container');

  function show() {
    if (typeof MicroModal === 'undefined') return;
    try {
      MicroModal.show('language-popup', {
        onShow: function () {
          modal.classList.add('loaded');
          if (container) container.classList.add('loaded');
          if (backdrop) backdrop.style.display = 'block';
          document.body.classList.add('modal-active');
        },
        onClose: function () {
          writePreference(DISMISSED);
          if (container) container.classList.remove('loaded');
          if (backdrop) backdrop.style.display = 'none';
          setTimeout(function () {
            modal.classList.remove('loaded');
            document.body.classList.remove('modal-active');
          }, 250);
        }
      });
    } catch (e) {
      console.log('language popup error: ', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', show);
  } else {
    show();
  }
})();
